import { render } from "./BlogGridPage.vue?vue&type=template&id=efc34c3e"
import script from "./BlogGridPage.vue?vue&type=script&lang=js"
export * from "./BlogGridPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__